// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@awc/Overrides/Components/ProductSelector";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productSelectorStyles.container = {
    gap: 12,
    offsetCss: css`
        align-items: flex-end;
    `,
};

productSelectorStyles.qtyGridItem = {
    css: css`
        &&& {
            align-items: center;
            ${TypographyStyle} {
                text-transform: uppercase;
                font-weight: ${fontConfig.weight.bold};
                margin-right: 8px;
                word-break: keep-all;
            }

            width: 170px;
            max-width: unset;
            flex-basis: unset;
        }
    `,
};

productSelectorStyles.clearIcon = {
    size: 16,
    css: css`
        position: absolute;
        right: 32px;
        top: 32px;
        cursor: pointer;
        &:hover {
            color: ${color("common.ui3")};
        }
    `,
};

productSelectorStyles.unitOfMeasureGridItem = {
    css: css`
        max-width: unset;
        flex-basis: unset;
        width: 250px;
        &:empty {
            display: none;
        }
    `,
};

productSelectorStyles.unitOfMeasureSelect = {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            max-width: 136px;
            min-width: 80px;
        `,
    },
    labelProps: {
        css: css`
            text-transform: uppercase;
        `,
    },
};

productSelectorStyles.searchGridItem = {
    width: [6, 6, 6, 5, 5],
    css: css`
        position: relative;
        &&& {
            max-width: 250px;
        }
    `,
};

productSelectorStyles.searchDynamicDropdown = {
    sizeVariant: "small",
};

productSelectorStyles.buttonGridItem = {
    width: [12, 6, 6, 3, 3],
    css: css`
        min-width: 111px;
        ${xScreen("lte", "sm")} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

productSelectorStyles.selectButton = {
    sizeVariant: "small",
    css: css`
        min-width: 111px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

productSelectorStyles.quoteButton = {
    sizeVariant: "small",
    variant: "secondary",
    css: css`
        min-width: 111px;
        text-transform: uppercase;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

productSelectorStyles.qtyFieldStyle = {
    qtyLabel: {
        css: css`
            &:after {
                content: none;
            }
        `,
    },
    wrapper: {
        css: css`
            max-width: unset;
        `,
    },
    editableQuantityTextField: {
        css: css`
            max-height: 32px;
        `,
    },
};
